import React from 'react'

export default function hero(props) {
  return (
    <main className='main'>
        <div className="articles">
          <img src={props.imageUrl} alt="japan" className="articles-img" />
          <div className="articles-text">
            <div className="articles-location">
            <i className="fa-solid fa-location-dot articles-location-sign"></i>
            <p className="articles-location-name">{props.location}</p>
            <a href={props.googleMapsUrl} className= "articles-location-url">View on Google Maps</a>
            </div>
            <h1 className="articles-heading">{props.title}</h1>
            <p className="articles-date">{props.startDate}-{props.endDate}</p>
            <p className="articles-para">{props.description}</p>
            <a href={props.more} className= "articles-location-url more">More ↘</a>
          </div>
        </div>
    </main>
  )
}
